module.exports = __webpack_public_path__ + "static/media/user-image.3cd73997.svg";